import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ui-names-tooltip',
  standalone: true,
  templateUrl: './names-tooltip.component.html',
  styleUrl: './names-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NamesTooltipComponent {
  names = input<string[]>([]);
}
